import { render, staticRenderFns } from "./AfterOrderList.vue?vue&type=template&id=378dffe7&scoped=true"
import script from "./AfterOrderList.vue?vue&type=script&lang=js"
export * from "./AfterOrderList.vue?vue&type=script&lang=js"
import style0 from "./AfterOrderList.vue?vue&type=style&index=0&id=378dffe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378dffe7",
  null
  
)

export default component.exports